import React from 'react';
import CustomIcon from '../Common/CustomIcon/CustomIcon.js';

import {
	v4 as uuidv4,
} from 'uuid';

import style from './ListingConfig.module.css';

import {
	buildTestData,
} from 'Vulture/TestData.js';
import NewListingModal from './NewListingModal.js';

import {
	providerListToColumnMap,
} from './listingIntegrationModels.js';

import {
	fetchListingColumnTypes,
} from 'Vulture/Listing.js';

import {
	ListingConfigTier,
} from './ListingConfigTier.js';

class ListingConfig extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			listingColumnTypeOptions: [],
			searchTerm:               '',
			expandedAccordions:       {}, // Track which accordions are expanded
		};
	}

	async componentDidMount() {
		await this.fetchListingColumnTypes();
	}

	// Fetch all the possible listing_config_column entities
	async fetchListingColumnTypes() {
		const contents = await fetchListingColumnTypes();

		if (contents) {
			let listingColumnTypeOptions = [];
			if (contents?.data) {
				contents.data.forEach((listing_column_type) => {
					const {
						display_name,
						uuid,
					} = listing_column_type;

					listingColumnTypeOptions.push({
						label: display_name,
						value: uuid,
					});
				});
			}

			this.setState({
				listingColumnTypeOptions,
			});
		}
	}

	handleMakeNewListingConfig(parentM1, parentM1UUID, shouldScroll = true) {
		const {
			app,
		} = this.props;

		const newListingConfigUUID = uuidv4();
		const newKeyVals = {
			// Add listing_config entity.
			[`listing_config.${newListingConfigUUID}.content_group_count`]: 1,
			[`listing_config.${newListingConfigUUID}.data_width`]:          80,
			[`listing_config.${newListingConfigUUID}.display_name`]:        '',

			// Add parent_to_listing_config relation.
			[`${parentM1}.${parentM1UUID}.listing_config.${newListingConfigUUID}`]: {},
		};

		app.createListingConfig(newListingConfigUUID, parentM1, parentM1UUID);
		app.setValue('account_settings', Object.keys(newKeyVals), Object.values(newKeyVals));

		// Only scroll and open accordion for root-level configs
		if (shouldScroll) {
			setTimeout(() => {
				this.scrollToBottomAndOpenAccordion(newListingConfigUUID);
			}, 100);
		}
	}

	handleImportListingConfig(parentM1, parentM1UUID, dataSetUUID) {
		const {
			app,
			dataSets,
		} = this.props;

		const tiers = JSON.parse(dataSets[dataSetUUID].json).tiers;

		let parent = parentM1;
		let parentUUID = parentM1UUID;

		const newKeyVals = {};
		const newListingConfigUUIDs = [];

		for (let i = 0; i < tiers.length; i++) {
			const newListingConfigUUID = uuidv4();
			newKeyVals[`listing_config.${newListingConfigUUID}.content_group_count`] = 1;
			newKeyVals[`listing_config.${newListingConfigUUID}.data_width`] = 80;
			newKeyVals[`listing_config.${newListingConfigUUID}.display_name`] = tiers[i].listName;

			newKeyVals[`${parent}.${parentUUID}.listing_config.${newListingConfigUUID}`] = {};

			const data = tiers[i].data;

			for (let j = 0; j < data.length; j++) {
				const newListingColumnUUID = uuidv4();

				newKeyVals[`listing_column.${newListingColumnUUID}.display_name`] = data[j].label;
				newKeyVals[`listing_column.${newListingColumnUUID}.listing_column_type.${data[j].type.value}`] = {};

				newKeyVals[`listing_config.${newListingConfigUUID}.listing_column.${newListingColumnUUID}`] = true;
				newKeyVals[`listing_config.${newListingConfigUUID}.listing_column.${newListingColumnUUID}.order`] = j + 1;
				newKeyVals[`listing_config.${newListingConfigUUID}.listing_column.${newListingColumnUUID}.width`] = Math.floor(100 / data.length);
			}


			parent = 'listing_config';
			parentUUID = newListingConfigUUID;
			newListingConfigUUIDs.push(newListingConfigUUID);
		}

		app.createListingConfigs(newListingConfigUUIDs, parentM1, parentM1UUID);
		app.setValue('account_settings', Object.keys(newKeyVals), Object.values(newKeyVals));

		// Scroll to bottom and open the first new accordion after a short delay
		if (newListingConfigUUIDs.length > 0) {
			setTimeout(() => {
				this.scrollToBottomAndOpenAccordion(newListingConfigUUIDs[0]);
			}, 100);
		}
	}

	handleIntegrateListingConfig(parentM1, parentM1UUID, integrationProvider, selectedIntegrationList) {
		const {
			app,
			settingMap,
		} = this.props;

		const {
			listingColumnTypeOptions,
		} = this.state;

		const providerUUID = settingMap['listing_integration_provider'].uuid;
		const providerListUUID = settingMap['listing_integration_list'].uuid;

		const newKeyVals = {};
		const newListingConfigUUIDs = [];

		const newListingConfigUUID = uuidv4();
		newKeyVals[`listing_config.${newListingConfigUUID}.content_group_count`] = 1;
		newKeyVals[`listing_config.${newListingConfigUUID}.data_width`] = 80;
		newKeyVals[`listing_config.${newListingConfigUUID}.display_name`] = selectedIntegrationList;

		newKeyVals[`listing_config.${newListingConfigUUID}.setting.${providerUUID}`] = true;
		newKeyVals[`listing_config.${newListingConfigUUID}.setting.${providerUUID}.string`] = integrationProvider.toLowerCase();
		newKeyVals[`listing_config.${newListingConfigUUID}.setting.${providerListUUID}`] = true;
		newKeyVals[`listing_config.${newListingConfigUUID}.setting.${providerListUUID}.string`] = selectedIntegrationList.toLowerCase();

		const columnsToBuild = providerListToColumnMap[integrationProvider][selectedIntegrationList];

		Object.entries(columnsToBuild).forEach(([ column, columnType, ], i, array) => {
			const newListingColumnUUID = uuidv4();
			const columnTypeUUID = listingColumnTypeOptions.find((listingColumnTypeOption) => {
				return listingColumnTypeOption.label === columnType;
			}).value;

			newKeyVals[`listing_column.${newListingColumnUUID}.display_name`] = column;
			newKeyVals[`listing_column.${newListingColumnUUID}.listing_column_type.${columnTypeUUID}`] = true;

			newKeyVals[`listing_config.${newListingConfigUUID}.listing_column.${newListingColumnUUID}`] = true;
			newKeyVals[`listing_config.${newListingConfigUUID}.listing_column.${newListingColumnUUID}.order`] = i + 1;
			newKeyVals[`listing_config.${newListingConfigUUID}.listing_column.${newListingColumnUUID}.width`] = Math.floor(100 / array.length);
		});

		newKeyVals[`${parentM1}.${parentM1UUID}.listing_config.${newListingConfigUUID}`] = {};

		newListingConfigUUIDs.push(newListingConfigUUID);

		app.createListingConfigs(newListingConfigUUIDs, parentM1, parentM1UUID);
		app.setValue('account_settings', Object.keys(newKeyVals), Object.values(newKeyVals));

		// Scroll to bottom and open the new accordion after a short delay
		setTimeout(() => {
			this.scrollToBottomAndOpenAccordion(newListingConfigUUID);
		}, 100);
	}

	openNewListingModal(parentM1, parentM1UUID) {
		const {
			app,
			dataSets,
		} = this.props;

		app.openModal({
			modalSize:  4,
			showModal:  true,
			modalProps: {
				title: 'New Listing',
				jsx:   (
					<NewListingModal
						app={this.props.app}
						dataSets={dataSets}
						newListing={() => {
							const shouldScroll = parentM1 === 'account';
							this.handleMakeNewListingConfig(parentM1, parentM1UUID, shouldScroll);
						}}
						importListing={(selectedDataSet) => {
							this.handleImportListingConfig(parentM1, parentM1UUID, selectedDataSet);
						}}
						integrateListing={(selectedIntegration, selectedIntegrationList) => {
							this.handleIntegrateListingConfig(parentM1, parentM1UUID, selectedIntegration, selectedIntegrationList);
						}}
						closeModal={() => {
							app.setState({
								modal:      false,
								modalProps: {},
							});
						}}
					/>
				),
			},
		});
	}

	findChildEntitiesForRender(m1, parentUUID) {
		const {
			listingConfigMap,
		} = this.props;

		let childEntities = [];
		if (listingConfigMap[parentUUID]) {
			for (let childUUID of listingConfigMap[parentUUID].childTiers) {
				childEntities.push({
					uuid: childUUID,
					data: listingConfigMap[childUUID],
				});
			}
		}

		return childEntities;
	}

	// Build a hierarchical tree structure for tiers
	buildTierHierarchy() {
		const {
			fd,
			listingConfigMap,
		} = this.props;

		// Find the tier one listing_config entities.
		let listingConfigTierOneEntities = [];
		for (let [ m1Key, m1Data, ] of Object.entries(fd)) {
			if (m1Key.startsWith('account.')) {
				for (let m2Key of Object.keys(m1Data)) {
					if (m2Key.startsWith('listing_config.')) {
						let m2UUID = m2Key.split('.')[1];
						listingConfigTierOneEntities.push(m2UUID);
					}
				}
			}
		}

		// Build hierarchy for each root config
		return listingConfigTierOneEntities.map((rootUUID) => {
			const buildTierTree = (configUUID, level = 1) => {
				const config = listingConfigMap[configUUID];
				if (!config) return null;

				const children = config.childTiers || [];
				return {
					uuid:     configUUID,
					level,
					config,
					children: children.map((childUUID) => {
						return buildTierTree(childUUID, level + 1);
					}).filter(Boolean),
				};
			};

			return buildTierTree(rootUUID);
		}).filter(Boolean);
	}

	// Render a single tier hierarchy horizontally
	renderTierHierarchy(tierTree, listNumber) {
		const {
			app,
			accountUUID,
			fd,
			listingConfigMap,
			settingMap,
		} = this.props;

		// Flatten the hierarchy into horizontal tiers
		const getAllTierLevels = (node, levels = {}) => {
			if (!node) return levels;

			const level = node.level;
			if (!levels[level]) levels[level] = [];
			levels[level].push(node);

			// Recursively process children
			if (node.children && node.children.length > 0) {
				node.children.forEach((child) => {
					return getAllTierLevels(child, levels);
				});
			}

			return levels;
		};

		const tierLevels = getAllTierLevels(tierTree);
		const maxLevel = Math.max(...Object.keys(tierLevels).map(Number));
		const accordionId = `accordion-${tierTree.uuid}`;
		const isExpanded = this.state.expandedAccordions[accordionId] === true; // Default to collapsed

		// Get the root config display name for the accordion header
		const rootConfigName = tierTree.config?.display_name || `List ${listNumber}`;

		// Generate breadcrumb content for when accordion is collapsed
		const getBreadcrumbContent = () => {
			if (isExpanded) return null;

			const tierCount = maxLevel;
			// Count columns using the same logic as ListingConfigTier.js
			const {
				fd,
			} = this.props;
			let totalColumns = 0;

			// Traverse all nodes in the tier tree to count columns
			const countColumnsInNode = (node) => {
				if (node.uuid && fd[`listing_config.${node.uuid}`]) {
					// Count listing_column entries that are truthy (active columns)
					for (const [ m1Key, m1Data, ] of Object.entries(fd[`listing_config.${node.uuid}`])) {
						if (m1Key.startsWith('listing_column.') && m1Data) {
							totalColumns++;
						}
					}
				}
				// Recursively count columns in child nodes
				if (node.children) {
					node.children.forEach((child) => {
						return countColumnsInNode(child);
					});
				}
			};

			countColumnsInNode(tierTree);

			return `${tierCount} tier${tierCount !== 1 ? 's' : ''} • ${totalColumns} column${totalColumns !== 1 ? 's' : ''}`;
		};

		return (
			<div className={style.accordionWrapper}>
				{/* Accordion Header */}
				<div
					className={`${style.accordionHeader} ${isExpanded ? style.accordionHeaderExpanded : ''}`}
					onClick={() => {
						return this.toggleAccordion(accordionId);
					}}
				>
					<div className={style.accordionHeaderContent}>
						<div className={style.accordionHeaderText}>
							<h3 className={style.accordionTitle}>{rootConfigName}</h3>
							{getBreadcrumbContent() && (
								<span className={style.accordionBreadcrumb}>
									{getBreadcrumbContent()}
								</span>
							)}
						</div>
						<div className={style.accordionIcon}>
							<CustomIcon icon={isExpanded ? 'chevron-down' : 'chevron-right'} />
						</div>
					</div>
				</div>

				{/* Accordion Content */}
				<div className={`${style.accordionContent} ${isExpanded ? style.accordionContentExpanded : style.accordionContentCollapsed}`}>
					<div className={style.tierHierarchy}>
						<div className={style.tierHorizontalContainer}>
							{Array.from({
								length: maxLevel,
							}, (_, i) => {
								return i + 1;
							}).map((level) => {
								const nodesAtLevel = tierLevels[level] || [];
								if (nodesAtLevel.length === 0) return null;

								return (
									<div key={`tier-${level}`} className={style.tierColumn}>
										<div className={style.tierColumnNodes}>
											{nodesAtLevel.map((node, index) => {
												return (
													<div key={node.uuid} className={style.tierNodeWrapper}>
														<ListingConfigTier
															app={app}
															fd={fd}
															accountUUID={accountUUID}
															parentM1={level === 1 ? 'account' : 'listing_config'}
															parentM1UUID={level === 1 ? accountUUID : node.uuid}
															listingConfigMap={listingConfigMap}
															listingConfigUUID={node.uuid}
															settingMap={settingMap}
															listNumber={listNumber}
															listingColumnTypeOptions={this.state.listingColumnTypeOptions}
															pendingChanges={this.props.pendingChanges}
															messageLabels={this.props.messageLabels}
															tier={level}
															hideChildRendering={true}
															openNewListingModal={this.openNewListingModal.bind(this)}
															findChildEntitiesForRender={this.findChildEntitiesForRender.bind(this)}
															handleMakeNewListingConfig={(parentM1, parentM1UUID) => {
																return this.handleMakeNewListingConfig(parentM1, parentM1UUID, false);
															}
															}
														/>
													</div>
												);
											})}
										</div>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		);
	}

	// Scroll to bottom and open the accordion for the newly created listing config
	scrollToBottomAndOpenAccordion = (newListingConfigUUID) => {
		// Scroll to the bottom of the page
		window.scrollTo({
			top:      document.documentElement.scrollHeight,
			behavior: 'smooth',
		});

		// Open the accordion for the new listing config
		const accordionId = `accordion-${newListingConfigUUID}`;
		this.setState((prevState) => {
			return {
				expandedAccordions: {
					...prevState.expandedAccordions,
					[accordionId]: true,
				},
			};
		});
	}

	handleSearchChange = (e) => {
		this.setState({
			searchTerm: e.target.value,
		});
	}

	// Toggle accordion state
	toggleAccordion = (accordionId) => {
		this.setState((prevState) => {
			return {
				expandedAccordions: {
					...prevState.expandedAccordions,
					[accordionId]: !prevState.expandedAccordions[accordionId],
				},
			};
		});
	}

	filterTierHierarchies(tierHierarchies) {
		const {
			searchTerm,
		} = this.state;

		if (!searchTerm.trim()) {
			return tierHierarchies;
		}

		const searchLower = searchTerm.toLowerCase();

		return tierHierarchies.filter((tierTree) => {
			// Check if the root config matches
			const rootConfig = tierTree.config;
			const rootName = rootConfig?.display_name || '';

			if (rootName.toLowerCase().includes(searchLower)) {
				return true;
			}

			// Check children recursively
			const checkChildren = (node) => {
				if (node.config?.display_name?.toLowerCase().includes(searchLower)) {
					return true;
				}
				return node.children?.some((child) => {
					return checkChildren(child);
				}) || false;
			};

			return checkChildren(tierTree);
		});
	}

	renderListingConfigs() {
		const tierHierarchies = this.buildTierHierarchy();
		const filteredHierarchies = this.filterTierHierarchies(tierHierarchies);
		let listNumber = 0;

		if (filteredHierarchies.length === 0 && this.state.searchTerm.trim()) {
			return (
				<div className={style.noResultsMessage}>
					<p>No listing configurations found matching "{this.state.searchTerm}"</p>
				</div>
			);
		}

		return (
			<div className={style.listingConfigsContainer}>
				{filteredHierarchies.map((tierTree) => {
					listNumber++;
					return (
						<div
							className={style.listingContainer}
							key={tierTree.uuid}
						>
							{this.renderTierHierarchy(tierTree, listNumber)}
						</div>
					);
				})}
			</div>
		);
	}

	render() {
		const {
			accountUUID,
		} = this.props;

		return (
			<div className={style.listingConfigWrapper}>
				<div className={style.listingConfigHeader}>
					<button
						className={`button ${style.button}`}
						onClick={(e) => {
							e.preventDefault();
							this.openNewListingModal('account', accountUUID);
						}}
						data-testing-info={buildTestData('button--newList')}
					>
						<CustomIcon icon='plus' /> New List Configuration
					</button>

					<div className={style.searchContainer}>
						<input
							type="text"
							placeholder="Search by list name..."
							value={this.state.searchTerm}
							onChange={this.handleSearchChange}
							className={style.searchInput}
						/>
						<CustomIcon icon='search' className={style.searchIcon} />
					</div>
				</div>

				{this.renderListingConfigs()}
			</div>
		);
	}
}

export default ListingConfig;